import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import {
  Tab,
  Tabs,
  makeStyles,
  Typography,
  Button,
} from '@material-ui/core';
import {
  CommonDialog,
  NormPriceComposition,
  NormCoefficients,
  EstimatePriceSettings,
} from 'components';
import EstimateObjectSettingsModal from './EstimateObjectSettingsModal';
import api from 'utils/api';

const TABS = {
  PRICE_COMPOSITION: 'price_composition',
  COEFFICIENTS: 'coefficients',
  PRICE_SETTINGS: 'price_settings',
  JOB_COMPOSITION: 'job_composition',
  OBJECT_SETTINGS: 'object_settings',
}

const useStyles = makeStyles({
  root: {},
  filePickerTableContainer: {
    maxWidth: 800,
  },
  footerWrap: {
    marginTop: 40,
  }
})

const ObjectSummaryModal = ({ objectId, itemId, onClose, onChange, readOnly = false, isEstimate = true }) => {
  const history = useHistory();
  const classes = useStyles();
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(TABS.PRICE_COMPOSITION);
  const [loading, setLoading] = useState(false);
  const [item, setItem] = useState(null);
  const [title, setTitle] = useState(null);
  const [hadChanges, setHadChanges] = useState(false);
  const [priceSettings, setPriceSettings] = useState(null);
  const [coefficients, setCoefficients] = useState(null);

  // If work report data - only allow read-only mode
  if (!isEstimate) readOnly = true;

  const fetchItem = async () => {
    setLoading(true);

    try {
      const { data } = isEstimate ? await api.get(`/estimates/${objectId}/summary`) : await api.get(`/work-reports/${objectId}/summary`);
      setItem({ ...data });
      setPriceSettings(data.priceSettings);
      setCoefficients(_.pick(data, ['coefficients', 'coefficientsSpec', 'customCoefficients']));

      setTitle(<><b>{data.code}</b> {data.title}</>);
    } catch (err) {
      console.error(err);
    }


    setLoading(false);
  }

  useEffect(() => {
    if (!item) fetchItem();
  }, []);

  const handleClose = (changed = false) => {
    onClose(hadChanges || changed);
  };

  const handleTabChange = (event, tabCode) => {
    setActiveTab(tabCode);
    return;
  };

  const onPriceSettingsChange = async (priceSettings) => {
    setPriceSettings([...priceSettings]);
  };

  const handleSubmit = async (type) => {
    setLoading(true);

    if (type === 'price-settings') {
      try {
        await api.put(`/estimates/${objectId}/price-settings`, priceSettings);

        setHadChanges(true);

        await fetchItem();
      } catch (err) {
        console.error(err);
      }
    } else {
      window.alert('Unknown type ' + type);
    }

    setLoading(false);
  }

  const actions = (
    <>
      {(activeTab === TABS.COEFFICIENTS || activeTab === TABS.PRICE_SETTINGS) && !readOnly && (
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleSubmit(activeTab === TABS.COEFFICIENTS ? 'coefficients' : 'price-settings')}
        >
          {activeTab === TABS.COEFFICIENTS ? t('Perskaičiuoti su koeficientais') : t('Perskaičiuoti su kainos nustatymais')}
        </Button>
      )}

      <Button
        color="primary"
        onClick={handleClose}
      >
        Uždaryti
      </Button>
    </>
  );

  return (
    <CommonDialog
      visible
      onClose={handleClose}
      maxWidth="md"
      style={{ position: 'relative' }}
      showClose
      actions={actions}
      disableBackdropClick
    >
      {title && (
        <Typography variant="body1">
          {title}
        </Typography>
      )}

      <Tabs
        value={activeTab}
        indicatorColor="primary"
        textColor="primary"
        onChange={handleTabChange}
      >
        <Tab label={t("Kainos sudėtis")} value={TABS.PRICE_COMPOSITION} />
        {/* {isRate && <Tab label={t("Darbų sudėtis")} value={TABS.JOB_COMPOSITION} disabled={!item?.workComposition} />}
        {isRate && <Tab label={t("Koeficientai")} value={TABS.COEFFICIENTS} />} */}
        <Tab label={t("Darbo kainos nustatymai")} value={TABS.PRICE_SETTINGS} />
        {isEstimate && <Tab label={t("Skaičiavimų nustatymai")} value={TABS.OBJECT_SETTINGS} />}
      </Tabs>

      <div style={{ minHeight: '450px', marginTop: '10px' }}>
        {activeTab === TABS.PRICE_COMPOSITION && <NormPriceComposition hideAdditionals item={item} />}
        {/* {activeTab === TABS.JOB_COMPOSITION && isRate && <Typography variant="body1">{item?.workComposition}</Typography>} */}
        {/* {activeTab === TABS.COEFFICIENTS && isRate && <NormCoefficients onChange={onCoefficientsChange} item={item} />} */}
        {activeTab === TABS.PRICE_SETTINGS && <EstimatePriceSettings readOnly={readOnly} isRate={false} onChange={onPriceSettingsChange} priceSettings={priceSettings} />}
        {activeTab === TABS.OBJECT_SETTINGS && <EstimateObjectSettingsModal totals={item?.totals} id={objectId} onClose={handleClose} />}
      </div>
    </CommonDialog>
  )
}

export default ObjectSummaryModal;